import { render, staticRenderFns } from "./Gerenciador.vue?vue&type=template&id=1e532893&scoped=true&"
import script from "./Gerenciador.vue?vue&type=script&lang=js&"
export * from "./Gerenciador.vue?vue&type=script&lang=js&"
import style0 from "./Gerenciador.vue?vue&type=style&index=0&id=1e532893&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e532893",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
